import { HIDDEN } from '../../classnames/design-system';
import { PURCHASE_TYPE } from '../product/constants';
import { SELECTORS } from './constants';

export class DiscountLabelHandler {
  handle = () => {
    const purchaseType = window.currentVariantStorage.state.subscription;
    const discounts = document.querySelectorAll(`.${SELECTORS.OTP_DISCOUNT}`);

    discounts.forEach((discount) => {
      if (purchaseType === PURCHASE_TYPE.OTP) {
        discount.classList.remove(HIDDEN);
      } else {
        discount.classList.add(HIDDEN);
      }
    });
  };
}
